import IntlMessageFormat from 'intl-messageformat'

import { isNumber } from './is-number'

export const getOrdinalNumber = (value: number) => {
  if (!isNumber(value) || value < 1) {
    return '-'
  }

  return new IntlMessageFormat(`{value}{value, plural,
    =1 {st}
    =2 {nd}
    =3 {rd}
    other {th}
  }`).format({ value })
}
